export const shortenAddress = (address: string): string => {
  if (!address) return "";
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
};

export const truncateToTwoDecimals = (num: number): number => {
  return Math.floor(num * 100) / 100;
};

export const formatNumber = (num: number) => num.toLocaleString();

export const toNumber = (value?: bigint): number => {
  return value !== undefined ? Number(value) : 0;
};
